export const USER_ADMIN_PAGE='USER_ADMIN_PAGE';
export const TREATMENT_ADMIN_PAGE='TREATMENT_ADMIN_PAGE';
